/**
 * Select - H5 版本，使用 zarm Select
 */
import React from 'react';
import { Select as ZarmSelect } from 'zarm-v3';
import { WheelItem } from 'zarm-v3/lib/wheel';

export interface SelectOption {
  value: string | number;
  label: string;
  children?: SelectOption[];
}

export interface IsomorphicSelectProps {
  dataSource: SelectOption[];
  value?: string | number | Array<string | number>;
  placeholder?: string;
  onOk?: (selected: SelectOption[]) => void;
  className?: string;
}

export const Select: React.FC<IsomorphicSelectProps> = ({ dataSource, value, placeholder, onOk, className }) => (
  <ZarmSelect
    dataSource={dataSource}
    value={value}
    placeholder={placeholder}
    onConfirm={(_, items: WheelItem[]) => onOk?.(items as SelectOption[])}
    className={className}
  />
);

export default Select;
